var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCoinsStacked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coins-stacked-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 3.33333C13.3333 4.4379 10.9455 5.33333 7.99996 5.33333C5.05444 5.33333 2.66663 4.4379 2.66663 3.33333M13.3333 3.33333C13.3333 2.22876 10.9455 1.33333 7.99996 1.33333C5.05444 1.33333 2.66663 2.22876 2.66663 3.33333M13.3333 3.33333V12.6667C13.3333 13.7712 10.9455 14.6667 7.99996 14.6667C5.05444 14.6667 2.66663 13.7712 2.66663 12.6667V3.33333M13.3333 6.4444C13.3333 7.54896 10.9455 8.4444 7.99996 8.4444C5.05444 8.4444 2.66663 7.54896 2.66663 6.4444M13.3333 9.55333C13.3333 10.6579 10.9455 11.5533 7.99996 11.5533C5.05444 11.5533 2.66663 10.6579 2.66663 9.55333",
    stroke: "#6C6C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoinsStacked);
export default __webpack_public_path__ + "static/media/ic-coins-stacked.97516b4a891c47f2fdeb97d497f0562a.svg";
export { ForwardRef as ReactComponent };